module.exports = "<router-outlet></router-outlet>>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/auth/auth.component.html
// module id = ./src/app/modules/auth/auth.component.html
// module chunks = main